import { useMemo } from 'react';
import type {
  TRichMessageBounds,
  TRichMessageTemplate,
} from 'types/richMessage';

type Props = {
  template: TRichMessageTemplate;
  isSelected: boolean;
  onClick: () => void;
};

const cell =
  'rounded-[1px] border border-neutral-400 bg-neutral-200/90 box-border';

function BoundsWireframe({
  size,
  bounds,
}: {
  size: { width: number; height: number };
  bounds: TRichMessageBounds[];
}) {
  const { width: W, height: H } = size;
  return (
    <div className="relative h-full w-full">
      {bounds.map((b, i) => (
        <div
          key={i}
          className={`absolute ${cell}`}
          style={{
            left: `${(b.x / W) * 100}%`,
            top: `${(b.y / H) * 100}%`,
            width: `${(b.width / W) * 100}%`,
            height: `${(b.height / H) * 100}%`,
          }}
        />
      ))}
    </div>
  );
}

export function RichMessageTemplateThumbnail({
  template,
  isSelected,
  onClick,
}: Props) {
  const aspectStyle = {
    aspectRatio: `${template.size.width} / ${template.size.height}`,
  };

  const wireframe = useMemo(
    () => <BoundsWireframe size={template.size} bounds={template.bounds} />,
    [template],
  );

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-[88px] flex-col items-center gap-1 rounded-lg transition ${
        isSelected
          ? 'ring-2 ring-emerald-500 ring-offset-2 ring-offset-white'
          : 'hover:opacity-90'
      }`}
    >
      <div
        className="w-full overflow-hidden rounded border border-neutral-300 bg-neutral-100 p-0.5"
        style={aspectStyle}
      >
        <div className="h-full w-full">{wireframe}</div>
      </div>
    </button>
  );
}
